import React from "react";

function VehicleWalkaroundCheck() {
  const handlePrint = () => {
    // This function triggers the browser's print dialog.
    window.print();
  };

  return (
    <>
      <div id="VehicleWalkaroundCheck-screen" className="flex flex-col items-center justify-center min-h-screen p-8 bg-gray-100 font-sans print:hidden">
        {/* This container is for the screen view only */}
        <div className="w-full max-w-4xl p-12 bg-white rounded-lg shadow-xl text-left border border-gray-300 transition-all duration-300">
          <h1 className="text-3xl font-bold uppercase text-center mb-8">
            16. VEHICLE WALK-AROUND CHECK
          </h1>

          {/* Top Section */}
          <div className="space-y-4 text-lg mb-8">
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Vehicle Registration:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Odometer Reading:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Date:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Checked By (Name):</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
          </div>

          <hr className="my-8 border-gray-300" />

          {/* Checklist Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 text-lg">
            {[
              "Fuel / oil / fluid leaks",
              "Battery secure",
              "Wheels, Tyres & Fixings",
              "Spray Suppression",
              "Registration Plates",
              "Bodywork Condition & Security",
              "Steering",
              "Brakes",
              "Air Build Up",
              "Licence Visibility",
              "Odometer / Speed Limiter",
              "Seat Belts & Cab Interior",
              "Tachograph & Tachograph Rolls",
              "Warning Lights",
              "Wipers & Washers",
              "Horn",
              "Glass & Mirrors",
              "Exhaust Smoke",
              "Reflectors, Markers & Lights",
              "Indicators & Hazard Lights",
              "Adblue / DEF",
              "Saloon / Coach Interior",
              "Heating & Ventilation",
              "Emergency Exits",
              "First Aid Kit",
              "Fire Extinguisher",
              "Passenger seat belts",
              "Wheelchair Access",
              "Prominent Warning Signage",
            ].map((item, index) => (
              <p key={index} className="flex justify-between items-center">
                <span>{item}:</span>
                <span className="flex items-center space-x-4">
                  <span className="flex items-center">
                    [ ] Yes
                  </span>
                  <span className="flex items-center">
                    [ ] No
                  </span>
                </span>
              </p>
            ))}
          </div>

          <hr className="my-8 border-gray-300" />

          {/* Fit to Drive Section */}
          <div className="space-y-4 text-lg">
            <p className="flex justify-between items-center">
              <span>Are You Fit to Drive:</span>
              <span className="flex items-center space-x-4">
                <span className="flex items-center">
                  [ ] Yes
                </span>
                <span className="flex items-center">
                  [ ] No
                </span>
              </span>
            </p>
            <p className="text-sm text-gray-600 italic mt-2">
              (by selecting 'yes', you confirm that you are fit to drive and have no medical conditions, no drug or alcohol use that would impair your ability to operate the vehicle safely and are well rested)
            </p>
            <p className="text-sm text-gray-600 italic">
              (by selecting 'no', you confirm that you are not fit to drive and will not operate the vehicle, you may also be subject to disciplinary action)
            </p>
          </div>

          <hr className="my-8 border-gray-300" />

          {/* Trailer Section */}
          <h2 className="text-2xl font-bold uppercase text-center mb-6">
            Trailer Details
          </h2>
          <div className="space-y-4 text-lg mb-8">
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Trailer Registration:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Trailer Type:</strong>
              <span className="flex-grow flex justify-around">
                [ ] Flatbed / [ ] Curtain Side / [ ] Box Trailer / [ ] Fridge / [ ] Other
              </span>
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 text-lg">
            {[
              "Trailer coupling",
              "Trailer Tyres",
              "Trailer Lights",
              "Trailer curtains",
              "Trailer brakes",
              "Trailer coupling security",
              "Trailer registration plates",
              "Trailer emergency brake cable",
              "Trailer emergency exit",
              "Trailer security seals",
              "Trailer load security",
              "5th Wheel Coupling",
            ].map((item, index) => (
              <p key={index} className="flex justify-between items-center">
                <span>{item}:</span>
                <span className="flex items-center space-x-4">
                  <span className="flex items-center">
                    [ ] Yes
                  </span>
                  <span className="flex items-center">
                    [ ] No
                  </span>
                </span>
              </p>
            ))}
          </div>

          <hr className="my-8 border-gray-300" />
          
          {/* Defects and Signatures Section */}
          <div className="space-y-4 text-lg">
            <p className="flex justify-between items-center">
              <span>Nil Defects Found:</span>
              <span className="flex items-center space-x-4">
                <span className="flex items-center">
                  [ ] Yes
                </span>
                <span className="flex items-center">
                  [ ] No
                </span>
              </span>
            </p>
            <p>
              <strong>Notes:</strong> [Record any defects found and actions taken]
              <span className="flex-grow border-b-2 border-dashed border-gray-400 mt-2 block h-10"></span>
            </p>
            <p className="flex items-center pt-8">
              <strong className="w-48 flex-shrink-0">Signature of Driver:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center pt-4">
              <strong className="w-48 flex-shrink-0">Signature of Manager:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
          </div>
        </div>
      </div>

      {/* Print Button - for screen only */}
      <div className="fixed bottom-8 right-8 print:hidden">
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white font-bold py-3 px-6 rounded-full shadow-lg hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-4 focus:ring-blue-300"
        >
          Print Check
        </button>
      </div>

      {/* This container is for the print view only */}
      <div id="VehicleWalkaroundCheck" className="hidden print:block">
        <div className="w-full max-w-4xl p-12 bg-white text-left">
          <h1 className="text-3xl font-bold uppercase text-center mb-8">
            16. VEHICLE WALK-AROUND CHECK
          </h1>
          {/* ... all the same content as above ... */}
          <div className="space-y-4 text-lg mb-8">
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Vehicle Registration:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Odometer Reading:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Date:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Checked By (Name):</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
          </div>

          <hr className="my-8 border-gray-300" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 text-lg">
            {[
              "Fuel / oil / fluid leaks",
              "Battery secure",
              "Wheels, Tyres & Fixings",
              "Spray Suppression",
              "Registration Plates",
              "Bodywork Condition & Security",
              "Steering",
              "Brakes",
              "Air Build Up",
              "Licence Visibility",
              "Odometer / Speed Limiter",
              "Seat Belts & Cab Interior",
              "Tachograph & Tachograph Rolls",
              "Warning Lights",
              "Wipers & Washers",
              "Horn",
              "Glass & Mirrors",
              "Exhaust Smoke",
              "Reflectors, Markers & Lights",
              "Indicators & Hazard Lights",
              "Adblue / DEF",
              "Saloon / Coach Interior",
              "Heating & Ventilation",
              "Emergency Exits",
              "First Aid Kit",
              "Fire Extinguisher",
              "Passenger seat belts",
              "Wheelchair Access",
              "Prominent Warning Signage",
            ].map((item, index) => (
              <p key={index} className="flex justify-between items-center">
                <span>{item}:</span>
                <span className="flex items-center space-x-4">
                  <span className="flex items-center">
                    [ ] Yes
                  </span>
                  <span className="flex items-center">
                    [ ] No
                  </span>
                </span>
              </p>
            ))}
          </div>

          <hr className="my-8 border-gray-300" />

          <div className="space-y-4 text-lg">
            <p className="flex justify-between items-center">
              <span>Are You Fit to Drive:</span>
              <span className="flex items-center space-x-4">
                <span className="flex items-center">
                  [ ] Yes
                </span>
                <span className="flex items-center">
                  [ ] No
                </span>
              </span>
            </p>
            <p className="text-sm text-gray-600 italic mt-2">
              (by selecting 'yes', you confirm that you are fit to drive and have no medical conditions, no drug or alcohol use that would impair your ability to operate the vehicle safely and are well rested)
            </p>
            <p className="text-sm text-gray-600 italic">
              (by selecting 'no', you confirm that you are not fit to drive and will not operate the vehicle, you may also be subject to disciplinary action)
            </p>
          </div>

          <hr className="my-8 border-gray-300" />

          <h2 className="text-2xl font-bold uppercase text-center mb-6">
            Trailer Details
          </h2>
          <div className="space-y-4 text-lg mb-8">
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Trailer Registration:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center">
              <strong className="w-48 flex-shrink-0">Trailer Type:</strong>
              <span className="flex-grow flex justify-around">
                [ ] Flatbed / [ ] Curtain Side / [ ] Box Trailer / [ ] Fridge / [ ] Other
              </span>
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 text-lg">
            {[
              "Trailer coupling",
              "Trailer Tyres",
              "Trailer Lights",
              "Trailer curtains",
              "Trailer brakes",
              "Trailer coupling security",
              "Trailer registration plates",
              "Trailer emergency brake cable",
              "Trailer emergency exit",
              "Trailer security seals",
              "Trailer load security",
              "5th Wheel Coupling",
            ].map((item, index) => (
              <p key={index} className="flex justify-between items-center">
                <span>{item}:</span>
                <span className="flex items-center space-x-4">
                  <span className="flex items-center">
                    [ ] Yes
                  </span>
                  <span className="flex items-center">
                    [ ] No
                  </span>
                </span>
              </p>
            ))}
          </div>

          <hr className="my-8 border-gray-300" />
          
          <div className="space-y-4 text-lg">
            <p className="flex justify-between items-center">
              <span>Nil Defects Found:</span>
              <span className="flex items-center space-x-4">
                <span className="flex items-center">
                  [ ] Yes
                </span>
                <span className="flex items-center">
                  [ ] No
                </span>
              </span>
            </p>
            <p>
              <strong>Notes:</strong> [Record any defects found and actions taken]
              <span className="flex-grow border-b-2 border-dashed border-gray-400 mt-2 block h-10"></span>
            </p>
            <p className="flex items-center pt-8">
              <strong className="w-48 flex-shrink-0">Signature of Driver:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
            <p className="flex items-center pt-4">
              <strong className="w-48 flex-shrink-0">Signature of Manager:</strong>
              <span className="flex-grow border-b-2 border-dashed border-gray-400 ml-2"></span>
            </p>
          </div>
        </div>
      </div>

     <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #VehicleWalkaroundCheck, #VehicleWalkaroundCheck * {
              visibility: visible;
            }
            #VehicleWalkaroundCheck {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            @page {
              size: A4;
              margin: 20mm;
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
    </>
  );
}

export default VehicleWalkaroundCheck;